import POKEMON_FORMS_RAW from '../../../shared/pokemon-forms.json'

export interface CosmeticPokemonForm {
  slug: string
  nameFr: string
  nameEn: string
  spriteSlug: string
  types: string[]
  notes?: string
}

type PokemonFormsConfig = {
  version: number
  formsByBaseSlug: Record<string, CosmeticPokemonForm[]>
}

const POKEMON_FORMS = POKEMON_FORMS_RAW as PokemonFormsConfig

export function getCosmeticFormsForSlug(slug: string): CosmeticPokemonForm[] {
  return POKEMON_FORMS.formsByBaseSlug[slug] ?? []
}

export function getCosmeticFormForSlug(
  baseSlug: string,
  formSlug: string | null | undefined
): CosmeticPokemonForm | null {
  if (!formSlug) return null
  return getCosmeticFormsForSlug(baseSlug).find((form) => form.slug === formSlug) ?? null
}

export function getPokemonDisplaySlug(pokemon: { slug: string; cosmeticFormSlug?: string | null }): string {
  return getCosmeticFormForSlug(pokemon.slug, pokemon.cosmeticFormSlug)?.spriteSlug ?? pokemon.slug
}

export function getPokemonDisplayName(pokemon: {
  slug: string
  nameFr: string
  nameEn: string
  cosmeticFormSlug?: string | null
}): { fr: string; en: string } {
  const form = getCosmeticFormForSlug(pokemon.slug, pokemon.cosmeticFormSlug)
  return form ? { fr: form.nameFr, en: form.nameEn } : { fr: pokemon.nameFr, en: pokemon.nameEn }
}
